module.exports = __webpack_public_path__ + "img/manducaLogoBlanco.jpg.81645eea.png";